
export const maxDecimals = ( num, decimals=10 )=>{
    const factor = Math.pow( 10,decimals );
    return Math.round(num * factor)/factor;
};

export const percentageString=(percentage)=>maxDecimals((Number(percentage)||0)*100, 2)+' %';
